import styles from './index.module.sass';

export default function Paginator({ totPages, actualPage, callback }) {
  function handleOnChange(e) {
    if (callback) callback(e);
  }
  let pages = [];
  for (let index = 1; index <= totPages; index++) {
    pages[index] = index;
  }
  let listPages = pages.map((page) => (
    <option value={page} key={page}>
      {page}
    </option>
  ));
  if (listPages.length === 0) listPages = 0;
  return (
    <select onChange={(e) => handleOnChange(e)} className={styles.selectcss} value={actualPage}>
      {listPages}
    </select>
  );
}
